import { getUnixTime, subHours } from "date-fns/esm";

import { RunState } from "types/generated";
import { isTerminalRunState } from "utils/run";
import { getNowTimeMs } from "utils/time";

import {
  RUN_TERMINATION_THRESHOLD_DAYS,
  RUN_TERMINATION_WARNING_WINDOW_DAYS,
} from "../../constants";

const HOURS_IN_DAY = 24;

export const getRunsToBeTerminatedLink = () => {
  const now = getNowTimeMs();

  const dateRange = {
    startDate: getUnixTime(subHours(now, RUN_TERMINATION_THRESHOLD_DAYS * HOURS_IN_DAY)),
    endDate: getUnixTime(
      subHours(
        now,
        (RUN_TERMINATION_THRESHOLD_DAYS - RUN_TERMINATION_WARNING_WINDOW_DAYS) * HOURS_IN_DAY
      )
    ),
  };

  return `/runs?filterValues=${btoa(
    encodeURIComponent(
      JSON.stringify([
        Object.values(RunState)
          .filter((state) => state !== RunState.Unknown && !isTerminalRunState(state))
          .map((value) => ({ value, label: value })),
      ])
    )
  )}&filterFields=${btoa(JSON.stringify(["state"]))}&dateRange=${btoa(JSON.stringify(dateRange))}`;
};
